import { createEffect, createEvent, createStore } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils, ApiUtils } from '@shared/utils';
import { TransactionsApi } from '@shared/api/rest';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

export const generateRecipientEffect = createEffect((params: IQueryParams<string>) => TransactionsApi.getReceipt(params.request, params?.signal));
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(generateRecipientEffect.pending, (_, data) => data)
  .on(generateRecipientEffect.fail, () => false)
  .on(generateRecipientEffect.done, () => false)
  .reset(clearEvent);

generateRecipientEffect.done.watch((result) => FileUtils.downloadFile(result.result));
generateRecipientEffect.fail.watch((x) => $notificationStore.events.setError(x.error.message));

export const $downloadRecipientStore = {
  events: {
    downloadRecipient: ApiUtils.wrapperApi(generateRecipientEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: {
    loading: $loadingStore,
  },
};
